import { ColumnConfig, CustomFieldsDrawerTabelColumnKey } from '../model';

export const CustomFieldsDrawerTableConfig: Record<
  CustomFieldsDrawerTabelColumnKey,
  ColumnConfig
> = {
  displayName: {
    name: 'Display Name',
  },
  type: {
    name: 'Type',
    alignment: 'center',
  },
  actions: {
    name: 'Actions',
    alignment: 'flex-end',
    isComponent: true,
  },
};
